module.exports = __webpack_public_path__ + "img/Trillionaire-5.8cc2347c.png";